import React from "react";
import {
  makeStyles,
  Box,
  Container,
  Grid,
  Typography,
  Button,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { AnimationOnScroll } from "react-animation-on-scroll";
const useStyles = makeStyles((theme) => ({
  nftCollectionBox: {
    position: "relative",
    zIndex: "9",
    padding: "50px 0",
    background: "rgba(255, 255, 255, 0.02)",
    "& .bannerImg": {
      bottom: "55px",
      zIndex: "-1",
      width: "auto",
      position: "absolute",
      maxWidth: "97%",
      [theme.breakpoints.down("xs")]: {
        right: "0",
        left: "0",
      },
    },
    "& .displayEnd": {
      alignItems: "end",
      [theme.breakpoints.down("md")]: {
        justifyContent: "center",
      },
    },
    "& img": {
      width: "auto",
      maxWidth: "100%",
      [theme.breakpoints.down("md")]: {
        maxWidth: "175px",
      },
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100px",
      },
      [theme.breakpoints.down("xs")]: {
        maxWidth: "70px",
      },
    },
    "& h2": {
      lineHeight: "60px",
    },
    "& p": { color: theme.palette.text.secondary },
    "& .collectionBox": {
      margin: "20px 0 60px",
      [theme.breakpoints.down("sm")]: {
        margin: "20px 0 90px",
      },
      [theme.breakpoints.down("xs")]: {
        margin: "10px 0 20px",
      },
    },
  },
}));
const data = [
  {
    image: "images/collection_1.png",
  },
  {
    image: "images/collection_2.png",
  },
  {
    image: "images/collection_3.png",
  },
  {
    image: "images/collection.png",
  },
];

function NftCollection() {
  const classes = useStyles();
  return (
    <>
      <Box className={classes.nftCollectionBox}>
        <Container maxWidth="md">
          <Box align="center">
            <AnimationOnScroll animateIn="animate__fadeInLeft">
              <Typography variant="h2" color="primary">
                High Quality NFT Collection
              </Typography>
            </AnimationOnScroll>
            <Box mt={1} className="collectionBox">
              <AnimationOnScroll animateIn="animate__fadeInUp">
                <Typography variant="body2" color="primary">
                  Where creativity meets technology - Fieres powered NFT
                  marketplace for the modern age.
                </Typography>
              </AnimationOnScroll>
              <Box mt={4}>
                <Button
                  variant="contained"
                  color="primary"
                  target="_blank"
                  href="https://nft.fierex.com/"
                  // href="https://nftcreationmarketplace.mobiloitte.org/"
                >
                  Explore NFT Marketplace
                </Button>
              </Box>
            </Box>
          </Box>
        </Container>
        <Container maxWidth="lg">
          <Box>
            <img
              src="images/collection_banner.png"
              alt="images"
              className="bannerImg"
            />
            <Box className="displayEnd ">
              {data.map((value, i) => (
                <AnimationOnScroll
                  animateIn="animate__fadeInUp"
                  delay={i * 500}
                >
                  <img src={value.image} alt="images" />
                </AnimationOnScroll>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>
    </>
  );
}

export default NftCollection;
